import { styled, css, Box } from '@goodrx/matisse';
import { mediaMinWidth } from 'app/lib/utils';

export const Divider = styled(Box).attrs(({ theme, ...props }: any) => ({
  my: theme.space[3],
  bg: theme.colors.greyLight,
  ...props,
}))(
  (p: any) => css`
    height: 1px;

    ${p.hideOnDesktop &&
    mediaMinWidth({
      md: css`
        display: none;
      `,
    })}
  `
);
